// hooks/useWhatsappActivityListData.ts
import { getAiSafetyWrongInfo } from '@api/services/analytics.service';
import useDataQuery from '@hooks/use-data-query';
import { useMemo } from 'react';

const useAiSafetyAnalysisListData = () => {
    const query = useDataQuery(['ai-safety-analysis'], () => getAiSafetyWrongInfo());

    const data = useMemo(() => query.data || [], [query.data]);

    return {
        data,
        isLoading: query.isLoading,
    };
};

export default useAiSafetyAnalysisListData;
